import React from 'react';
import { Link } from 'react-router-dom';

const MembershipCancel = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          {/* Cancel Icon */}
          <div className="mx-auto flex items-center justify-center h-24 w-24 rounded-full bg-yellow-100 mb-6">
            <svg className="h-12 w-12 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Payment Cancelled
          </h2>
          
          <p className="text-lg text-gray-600 mb-6">
            Your payment was cancelled and no charges were made to your account.
          </p>

          {/* Information Box */}
          <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">What happened?</h3>
            <p className="text-gray-600 text-left">
              You cancelled the payment process before it was completed. This is completely normal and happens when:
            </p>
            <ul className="text-left text-gray-600 mt-4 space-y-2">
              <li>• You decided to review membership options again</li>
              <li>• You encountered a technical issue</li>
              <li>• You want to use a different payment method</li>
              <li>• You need to apply a discount code</li>
            </ul>
          </div>

          {/* Next Steps */}
          <div className="bg-apn-blue text-white rounded-lg p-6 mb-6">
            <h3 className="text-lg font-semibold mb-4">Ready to try again?</h3>
            <p className="text-left mb-4">
              Your membership is still waiting for you! You can complete your registration at any time.
            </p>
            <ul className="text-left space-y-2">
              <li className="flex items-center">
                <svg className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
                All membership tiers are still available
              </li>
              <li className="flex items-center">
                <svg className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
                Discount codes can still be applied
              </li>
              <li className="flex items-center">
                <svg className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
                Multiple payment methods accepted
              </li>
            </ul>
          </div>

          {/* Action Buttons */}
          <div className="space-y-4">
            <Link
              to="/register"
              className="w-full bg-apn-blue text-white py-3 px-4 rounded-lg font-semibold hover:bg-blue-700 transition duration-200 block text-center"
            >
              Try Again
            </Link>
            
            <Link
              to="/about/membership"
              className="w-full bg-white text-apn-blue border border-apn-blue py-3 px-4 rounded-lg font-semibold hover:bg-gray-50 transition duration-200 block text-center"
            >
              Learn More About Membership
            </Link>
            
            <Link
              to="/"
              className="w-full bg-gray-100 text-gray-700 py-3 px-4 rounded-lg font-semibold hover:bg-gray-200 transition duration-200 block text-center"
            >
              Return to Home
            </Link>
          </div>

          {/* Support */}
          <div className="mt-8 text-center">
            <p className="text-sm text-gray-500">
              Having trouble with payment? 
              <Link to="/about/contact" className="text-apn-blue hover:text-blue-700 ml-1">
                Contact our support team
              </Link>
            </p>
          </div>

          {/* Alternative Options */}
          <div className="mt-6 p-4 bg-gray-100 rounded-lg">
            <h4 className="font-semibold text-gray-900 mb-2">Alternative Options</h4>
            <p className="text-sm text-gray-600">
              If you're experiencing payment issues, you can also contact us directly to arrange alternative payment methods or get assistance with your membership registration.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MembershipCancel;
